var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.87 49.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smartphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.5,0H2.36A2.36,2.36,0,0,0,0,2.36V47a2.36,2.36,0,0,0,2.36,2.36H24.51A2.36,2.36,0,0,0,26.87,47V2.36A2.37,2.37,0,0,0,24.5,0Zm1.58,47a1.58,1.58,0,0,1-1.57,1.57H2.36A1.58,1.58,0,0,1,.78,47V43h25.3ZM.82,39V6.12H26V39ZM26.08,5.33H.78v-3A1.57,1.57,0,0,1,2.36.79H24.51a1.57,1.57,0,0,1,1.57,1.57Zm-22-2.28a.54.54,0,1,1-.54-.53A.54.54,0,0,1,4.09,3.05Zm1.59,0a.54.54,0,0,1-.54.54.54.54,0,1,1,.54-.54Zm.56-.34H21.42v.54H6.24ZM21.42,46.07H6.24v-.54H21.42ZM23.85,3A.85.85,0,1,1,23,2.13.85.85,0,0,1,23.85,3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortrait);
export default __webpack_public_path__ + "static/media/portrait.881979fad7123ead78574112ab90d655.svg";
export { ForwardRef as ReactComponent };